import { get, writable } from 'svelte/store'

function sortArrayByRowOrder(array) {
  return array?.sort((a, b) => a.row_order - b.row_order) || []
}

function createOrgLibraryStorePhy() {
  const { subscribe, set, update } = writable({
    surveys: [],
    uploads: [],
    sharedWithMe: [],
    loading: false,
    query: null,
  })

  return {
    subscribe,
    set,
    update,
    getOrgLibraryListPhy: () => {
      const list = get(orgLibraryStorePhy)
      list.surveys = sortArrayByRowOrder(list.surveys)
      list.uploads = sortArrayByRowOrder(list.uploads)
      return list
    },
    refetch: () => {
      const store = get(orgLibraryStorePhy)
      if (store.query) {
        store.query()
      }
    },
  }
}

export const orgLibraryStorePhy = createOrgLibraryStorePhy()

function createOrgLibraryStoreApp() {
  const { subscribe, set, update } = writable({
    surveys: [],
    uploads: [],
    sharedWithMe: [],
    loading: false,
    query: null,
  })

  return {
    subscribe,
    set,
    update,
    getOrgLibraryListApp: () => {
      const list = get(orgLibraryStoreApp)
      list.surveys = sortArrayByRowOrder(list.surveys)
      list.uploads = sortArrayByRowOrder(list.uploads)
      return list
    },
    refetch: () => {
      const store = get(orgLibraryStoreApp)
      if (store.query) {
        store.query()
      }
    },
  }
}

export const orgLibraryStoreApp = createOrgLibraryStoreApp()
